<template>
    <div
        class="pa-inline-flex pa-h-6 pa-items-center pa-rounded pa-bg-opacity-80 pa-text-xs"
        :class="[levelBgColor]"
    >
        <span
            class="pa-mr-1 pa-h-full pa-rounded pa-p-1"
        >
            <slot name="num" />
        </span>
        <component :is="levelIcon" />
        <span class="pa-ml-1 pa-mr-2">{{ t('patent-view.compareView.similarity') }}
            <slot name="label">
                <span>{{ percentage }}%</span>
            </slot>
        </span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import IconSimilarHigh from '@/components/icons/IconSimilarHigh.vue';
import IconSimilarMiddle from '@/components/icons/IconSimilarMiddle.vue';
import IconSimilarLow from '@/components/icons/IconSimilarLow.vue';
import { useI18n } from '@/composables/use-i18n';
import _ from 'lodash';

const { t } = useI18n();

const props = defineProps<{
    similarity: number,
}>();
enum ESimilarLevel {
    LOW = 'LOW',
    HIGH = 'HIGH',
    MIDDLE = 'MIDDLE'
}

enum ESimilarColor {
    LOW = 'pa-bg-green-40',
    MIDDLE = 'pa-bg-yellow-40',
    HIGH = 'pa-bg-red-40'
}

const ESimilarIcon = {
    LOW: IconSimilarLow,
    MIDDLE: IconSimilarMiddle,
    HIGH: IconSimilarHigh,
};

const percentage = computed(() => {
    return (+props.similarity * 100).toFixed(1);
});

/**
 * 不同相似度区分层级
 */
const level = computed(() => {
    if (+percentage.value >= 90) return ESimilarLevel.HIGH;
    if (+percentage.value >= 60 && +percentage.value < 90) return ESimilarLevel.MIDDLE;
    return ESimilarLevel.LOW;
});

/**
 * 图标
 */
const levelIcon = computed(() => {
    return _.get(ESimilarIcon, level.value);
});

/**
 * 背景色
 */
const levelBgColor = computed(() => {
    return _.get(ESimilarColor, level.value);
});

</script>

<style scoped lang="scss">

</style>
